import React, { Component } from 'react';
import throttle from '../shared/throttle';
import { Table } from 'antd';
import jquery from 'jquery';

class TableC extends Component {
    state = {
        renderTable: null
    }

    componentDidMount() {
        const { reRenderTime } = this.props;
        throttle(this.setScrollTop, { time: 300 });
        throttle(this.setScrollLeft, { time: reRenderTime || 300 });
        throttle(this.renderTable);
    }

    componentDidUpdate(prevProps) {
        const { data, reRenderTime } = this.props;
        if (prevProps.data !== data) {
            throttle(this.setScrollTop, { time: 300 });
            throttle(this.setScrollLeft, { time: reRenderTime || 300 });
            throttle(this.renderTable);
        }
    }

    // 修复滚动条滚动到底部，切换页面后，行错乱的情况
    setScrollTop = () => {
        const { className = '' } = this.props;
        const $table = jquery(`.tableC${className ? ` .${className}` : ''} .ant-table-scroll .ant-table-body`);
        $table.scrollTop($table.scrollTop() - 0.01);
    }

    // 修复设置scroll.y后，数据从无到有时，列不对齐的情况
    setScrollLeft = () => {
        const { className = '' } = this.props;
        const $table = jquery(`.tableC${className ? ` .${className}` : ''} .ant-table-scroll .ant-table-body`);
        $table.scrollLeft($table.scrollLeft() - 0.01);
    }

    // 修复表格渲染完成时，fixed列不对齐
    renderTable = () => {
        this.setState({ renderTable: {} });
    }
    
    getDataSource = () => {
        const { data, pagination } = this.props;
        const { current = 1, pageSize } = pagination || {};
        const len = (data || []).length;
        const dataSource = (data || []).map((item, index) =>
            ({
                ...item,
                index: ((current - 1) || 0) * (pageSize || len) + 1 + index,
            })
        );
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams = {}, onChange } = this.props;
        sortParams.sort = sorter.field;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        onChange({
            pagination,
            sortParams,
        });
    }

    computeWidth = (list) => {
        let w = 0;
        list.forEach(item => {
            const { width, children } = item;
            if (children && Array.isArray(children)) {
                w += this.computeWidth(children);
            } else {
                w += width;
            }
        });
        return w;
    }

    render() {
        const { renderTable } = this.state;
        const {
            data,
            columns,
            bordered = true,
            scrollX = false,
            scrollY = false,
            loading = false,
            pagination = false,
            rowKey = 'index',
            className = '',
            rowClassName = () => void(0),
            rowSelection,
            onExpand = () => void(0),
            showUnderline = true,
        } = this.props;
        const scroll = {
            x: scrollX || this.computeWidth(columns) || false,
            y: (data || []).length > 1 ? scrollY : false
        };
        // 表格宽度小于页面宽度时，去除fixed
        if (this.tableWrapRef && this.tableWrapRef.offsetWidth > scroll.x) {
            columns.forEach(i => i.fixed = false);
        }
        return (
            <div className="tableC" ref={el => this.tableWrapRef = el}>
                <Table
                    renderTable={renderTable}
                    bordered={bordered}
                    loading={loading}
                    columns={columns}
                    className={className}
                    pagination={pagination}
                    dataSource={this.getDataSource()}
                    rowKey={record => record[rowKey]}
                    scroll={scroll}
                    onChange={this.handleTableChange}
                    rowClassName={rowClassName}
                    rowSelection={rowSelection}
                    onExpand={onExpand}
                />
                { (bordered && !pagination && showUnderline) && <div style={{position: 'relative', top: -1, borderBottom: '1px solid #e9e9e9'}} /> }
            </div>
        );
    }
}

export default TableC;


// WEBPACK FOOTER //
// ./src/components/basicElement/TableC.js